<template>
  <div class="txt-current-customer">
    <dyn-slot :slot-data="slotData"><slot name="txtContent"></slot></dyn-slot>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'

export default {
  name: 'CurrentCustomer',
  data () {
    return {
      currentCustomer: null
    }
  },
  computed: {
    slotData () {
      return this.currentCustomer || {}
    }
  },
  mixins: [
    transaction('currentCustomer')
  ],
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query currentCustomer {
           currentCustomer {
             firstName
             lastName
           }
}`, this, 'currentCustomer'
      )
    }
  }
}
</script>
